import { render, staticRenderFns } from "./CouponType.vue?vue&type=template&id=c1da5f32&"
import script from "./CouponType.vue?vue&type=script&lang=js&"
export * from "./CouponType.vue?vue&type=script&lang=js&"
import style0 from "./CouponType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports